import React from "react";
import Company from "../../models/company";
import {
  CContainer,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import CompanyForm from "./CompanyForm";

interface CompanyUpdateModalProps {
  show: boolean;
  company?: Company;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const CompanyUpdateModal: React.FC<CompanyUpdateModalProps> = ({
  show,
  company,
  onCancel,
  onSuccess,
}) => {
  const modalTitle = company
    ? `Editar Empresa: ${company.ruc}`
    : `Agregar Empresa`;

  const onClose = () => {
    onCancel();
  };

  return (
    <CModal show={show} onClose={onClose} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>{modalTitle}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          {show ? (
            <CompanyForm
              company={company}
              onCancel={onCancel}
              onSuccess={onSuccess}
              clearOnSuccess={false}
            />
          ) : (
            <></>
          )}
        </CContainer>
      </CModalBody>
    </CModal>
  );
};

export default CompanyUpdateModal;
